import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// import { Form, InputField } from '../form';
// import { FormGroup, Button } from 'reactstrap';


import { registrationSuccess, registrationUnload, loadApp } from '../../actions';
import Loading from '../helpers/Loading';


import { User } from '../../api';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import RegistrationForm from './RegistrationForm';

const mapStateToProps = state => ({ ...state.registration });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({registrationSuccess, loadApp, onUnload: registrationUnload}, dispatch);
};



class SignupPage extends Component {
  
  constructor (props){
    super(props);
    
    const { email, ref, project, mid, next } = queryString.parse(props.location.search) || {};
    const isAutoReg = !!email && ref !== 'member'
    
    if (isAutoReg) {
      User.create({email, ref, genpwd: true}).then(this.props.registrationSuccess, () => this.setState({loading: false}))
    }

    this.onSuccess = this.onSuccess.bind(this)
    this.state = {
      initialValues: {email, ref, mid},
      loading: isAutoReg,
      joinMemberForm: (ref === 'member'),
      projectName: project,
      next
    }
  }
  
  onSuccess (user) {
    const { registrationSuccess, loadApp } = this.props;
    const { next } = this.state;
    
    registrationSuccess({...user, next});
    loadApp(user);
  }
  
  render () {
    const { loading, joinMemberForm, projectName, initialValues, next } = this.state
    
    return loading ? <Loading /> : (
      <div className="panel">
        <div className="panel-body">
          <h3 className="text-center">{joinMemberForm ? `Sign up to join the ${projectName || ''} project` : 'Create your account'}</h3>
          <RegistrationForm {...{joinMemberForm, initialValues, onSuccess: this.onSuccess}} />
        </div>
        <div className="panel-footer text-center">
          <Link to={`/login?next=${next || '/'}`}>Already have an account? Sign in &rarr;</Link>
        </div>
      </div>
    )
  };
}


export default connect(mapStateToProps, matchDispatchToProps)(SignupPage);


// WEBPACK FOOTER //
// ./src/components/auth/Signup.js